module.exports = __webpack_public_path__ + "static/media/icon_z.f928295d.svg";